export const DASHBOARD_PDF_OVERLAY_ID = 'dashboard-pdf-overlay';
export const DASHBOARD_PDF_OVERLAY = `div#${DASHBOARD_PDF_OVERLAY_ID}`;
